// @todo refactor

const mq = window.matchMedia('(max-width: 740px)');
const isMobile = mq.matches;

export default class Autocomplete {
    constructor(el, app) {

    }

    start(selector, options) {
        $.fn.searchComplete = $(selector).autocomplete(options);
    }

    boot() {
        /**
         *  Ajax Autocomplete for jQuery, version 1.1.3
         *  (c) 2010 Tomas Kirda
         *
         *  Ajax Autocomplete for jQuery is freely distributable under the terms of an MIT-style license.
         *  For details, see the web site: http://www.devbridge.com/projects/autocomplete/jquery/
         *
         *  Last Review: 04/19/2010
         *
         *  Modified by bInTime and Futurumshop, do not replace with new version
         */

        /*jslint onevar: true, evil: true, nomen: true, eqeqeq: true, bitwise: true, regexp: true, newcap: true, immed: true */
        /*global window: true, document: true, clearInterval: true, setInterval: true, jQuery: true */

        (function ($) {
            let reEscape = new RegExp('(\\' + ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\'].join('|\\') + ')', 'g');

            function fnFormatResult(value, data, currentValue) {
                let pattern = '(' + currentValue.replace(reEscape, '\\$1') + ')';
                return String.prototype.replace.apply(value, new RegExp(pattern, 'gi'), '<strong>$1<\/strong>');
            }

            function Autocomplete(el, options) {
                this.el = $(el);
                this.el.attr('autocomplete', 'off');

                this.suggestions = [];
                this.data = [];
                this.badQueries = [];
                this.selectedIndex = -1;
                this.currentValue = this.el.val();
                this.intervalId = 0;
                this.cachedResponse = [];
                this.onChangeInterval = null;
                this.ignoreValueChange = false;
                this.serviceUrl = options.serviceUrl;
                this.isLocal = false;
                this.products = [];
                this.options = {
                    autoSubmit: false,
                    minChars: 1,
                    maxHeight: 300,
                    deferRequestBy: 0,
                    width: 0,
                    highlight: true,
                    params: {},
                    fnFormatResult: fnFormatResult,
                    delimiter: null,
                    zIndex: 200,
                    containerEl: $('body')
                };
                this.setOptions(options);
                this.initialize();
            }

            $.fn.autocomplete = function (options) {
                return new Autocomplete(this.get(0) || $('<input />'), options);
            };

            let delay;
            $('.searchInput').off('keyup').on('keyup', (event) => {
                if ((event.keyCode === 13) || isMobile) {
                    return;
                }
                clearTimeout(delay);
                delay = setTimeout(() => {
                    let query = $('.searchInput').val().trim();

                    if (! query) return;

                    // ======== Products ========
                    let str = document.location.protocol + '//' +
                        document.location.host + '/search/suggester/products?q=' +
                        query + '&sortBy%5Bpopularity%5D=desc&itemPerPage=3';
                    $.get(str, function(data) {
                        let $ul = $('div.products');
                        $ul.empty();
                        $ul.append(data.products);
                    });

                    // ========= Blogs =========
                    if (window.isSearchBlogSuggestionEnabled) {
                        const $blogSuggestions = $('div.blog-suggestions');
                        const blogsUrl = new URL('/search/suggester/blogs', document.location.origin);
                        blogsUrl.searchParams.set('q', query);

                        $.get(blogsUrl.toString(), (data) => {
                            $blogSuggestions.empty().append(data?.blogs || '');
                        });
                    }
                }, 500);
            });

            Autocomplete.prototype = {
                killerFn: null,

                initialize() {
                    this.killerFn = function (e) {
                        if (!$(e.target).parents('.searchResults').length) {
                            this.killSuggestions();
                            this.disableKillerFn();
                        }
                    }.bind(this);

                    if (!this.options.width) {
                        this.options.width = this.el.width();
                    }

                    this.container = this.options.containerEl;
                    this.suggestionsContainer = this.container.find('.suggestions');
                    this.productsContainer = this.container.find('.products');

                    if (window.opera) {
                        this.el.keypress(function (e) {
                            this.onKeyPress(e);
                        }.bind(this));
                    } else {
                        this.el.keydown(function (e) {
                            this.onKeyPress(e);
                        }.bind(this));
                    }

                    this.el.keyup(function (e) {
                        this.onKeyUp(e);
                    }.bind(this));

                    this.el.blur(function () {
                        this.enableKillerFn();
                    }.bind(this));
                },

                setOptions(value) {
                    let options = this.options;
                    $.extend(options, value);
                    if (options.lookup) {
                        this.isLocal = true;
                        if ($.isArray(options.lookup)) {
                            options.lookup = {suggestions: options.lookup, data: []};
                        }
                    }
                },

                clearCache() {
                    this.cachedResponse = [];
                    this.badQueries = [];
                },

                disable() {
                    this.disabled = true;
                },

                enable() {
                    this.disabled = false;
                },


                enableKillerFn() {
                    $(document).bind('click', this.killerFn);
                },

                disableKillerFn() {
                    $(document).unbind('click', this.killerFn);
                },

                killSuggestions() {
                    this.stopKillSuggestions();
                    this.intervalId = window.setInterval(function () {
                        this.hide();
                        this.stopKillSuggestions();
                    }.bind(this), 300);
                },

                stopKillSuggestions() {
                    window.clearInterval(this.intervalId);
                },

                onKeyPress(e) {
                    if (this.disabled || !this.enabled) {
                        return;
                    }
                    // return will exit the function
                    // and event will not be prevented
                    switch (e.keyCode) {
                        case 27: //KEY_ESC:
                            this.el.val(this.currentValue);
                            this.hide();
                            break;
                        case 9: //KEY_TAB:
                        case 13: //KEY_RETURN:
                          if (this.selectedIndex === -1) {
                            setTimeout(this.hide.bind(this), 1000);
                            return;
                          }
                          this.select(this.selectedIndex);
                          if (e.keyCode === 9) {
                            return;
                          }
                          break;
                        case 38: //KEY_UP:
                            this.moveUp();
                            break;
                        case 40: //KEY_DOWN:
                            this.moveDown();
                            break;
                        default:
                            return;
                    }
                    e.stopImmediatePropagation();
                    e.preventDefault();
                },

                onKeyUp(e) {
                    if (this.disabled) {
                        return;
                    }
                    switch (e.keyCode) {
                        case 38: //KEY_UP:
                        case 40: //KEY_DOWN:
                            return;
                    }
                    clearInterval(this.onChangeInterval);
                    if (this.currentValue !== this.el.val()) {
                        if (this.options.deferRequestBy > 0) {
                            // Defer lookup in case when value changes very quickly:
                            this.onChangeInterval = setInterval(function () {
                                this.onValueChange();
                            }.bind(this), this.options.deferRequestBy);
                        } else {
                            this.onValueChange();
                        }
                    }
                },

                onValueChange() {
                    clearInterval(this.onChangeInterval);
                    this.currentValue = this.el.val();
                    let query = this.getQuery(this.currentValue);

                    this.selectedIndex = -1;
                    if (this.ignoreValueChange) {
                        this.ignoreValueChange = false;
                        return;
                    }
                    if (query === '') {
                        this.hide();
                    } else {
                        this.getSuggestions(query);
                    }
                },

                getQuery(value) {
                    let delimiter = this.options.delimiter;
                    if (!delimiter) {
                        return $.trim(value);
                    }

                    let arr = value.split(delimiter);

                    return $.trim(arr[arr.length - 1]);
                },

                getSuggestionsLocal(query) {
                    let val, i;
                    let arr = this.options.lookup;
                    let result = {suggestions: [], data: []};

                    query = query.toLowerCase();
                    for (i = 0; i < arr.suggestions.length; i++) {
                        val = arr.suggestions[i];
                        if (val.toLowerCase().indexOf(query) === 0) {
                            result.suggestions.push(val);
                            result.data.push(arr.data[i]);
                        }
                    }
                    return result;
                },

                getSuggestions(query) {
                    let cr;
                    //cr = this.isLocal ? this.getSuggestionsLocal(q) : this.cachedResponse[q];
                    if (cr && $.isArray(cr.suggestions) && $.isArray(cr.html)) {
                        this.suggestions = cr.suggestions;
                        this.data = cr.data;
                        this.suggest();
                    } else if (!this.isBadQuery(query)) {
                        this.options.params.query = query;
                        $.get(`${this.serviceUrl}?query=${query.toLowerCase()}`)
                            .done(function (response) {
                                this.processResponse(response);
                            }.bind(this));
                    }
                },

                isBadQuery(query) {
                    let badQuery = $.grep(this.badQueries, (item) => {
                        return item.toLowerCase() === query.toLowerCase();
                    });

                    return badQuery.length > 0;
                },

                hide() {
                    this.enabled = false;
                    this.selectedIndex = -1;
                    this.hideResults();
                },

                suggest() {
                    if (this.suggestions.length === 0) {
                        this.hide();
                        return;
                    }

                    let category, div, i, suggestion;
                    let format = this.options.fnFormatResult;
                    let currentValue = this.getQuery(this.currentValue);

                    let mOver = function (xi) {
                        return function () {
                            this.activate(xi);
                        }.bind(this);
                    }.bind(this);

                    let mClick = function (xi) {
                        return function () {
                            this.select(xi);
                        }.bind(this);
                    }.bind(this);

                    let pClick = function (xi) {
                        return function () {
                            this.categorySelect(xi);
                        }.bind(this);
                    }.bind(this);

                    this.hideResults();
                    if (this.suggestions.length && this.suggestions[0]) {
                        suggestion = this.suggestions[0];
                        div = $((this.selectedIndex === i
                            ? '<div class="selected"'
                            : '<div') + ' title="' + suggestion + '">' + format(suggestion, this.data[0], currentValue) + '</div>');
                        div.mouseover(mOver(0));
                        div.click(mClick(0));

                        this.suggestionsContainer.append(div);

                        for (i = 1; i < this.suggestions.length; i++) {
                            suggestion = this.suggestions[i];
                            div = $((this.selectedIndex === i
                                ? '<div class="selected"'
                                : '<div') + ' title="' + suggestion + '">' + format(suggestion, this.data[i], currentValue) + '</div>');
                            div.mouseover(mOver(i));
                            div.click(mClick(i));
                            this.suggestionsContainer.append(div);
                        }
                    }

                    if (this.suggestions.length) {
                        this.enabled = true;
                        this.showResults();
                    }
                },

                processResponse(response) {
                    const currentValue = this.getQuery(this.currentValue);

                    if (!$.isArray(response.suggestionsUrl)) {
                        response.suggestionsUrl = [];
                    }
                    if (!this.options.noCache) {
                        this.cachedResponse[response.query] = response;
                        if (response.suggestions.length === 0) {
                            this.badQueries.push(response.query);
                        }
                    }
                    if (response.query.toLowerCase() === currentValue.toLowerCase()) {
                        this.suggestions = response.suggestions;
                        this.data = response.suggestionsUrl;
                        this.suggest();
                    }
                },

                activate(index) {
                    let activeItem;
                    let divs = this.suggestionsContainer.children();
                    // Clear previous selection:
                    if (this.selectedIndex !== -1 && divs.length > this.selectedIndex) {
                        $(divs.get(this.selectedIndex)).removeClass();
                    }
                    this.selectedIndex = index;
                    if (this.selectedIndex !== -1 && divs.length > this.selectedIndex) {
                        activeItem = divs.get(this.selectedIndex);
                        $(activeItem).addClass('selected');
                    }
                    return activeItem;
                },

                deactivate(div, index) {
                    div.className = '';
                    if (this.selectedIndex === index) {
                        this.selectedIndex = -1;
                    }
                },

                categorySelect(i) {
                    let selectedValue, f;
                    selectedValue = this.suggestions[0];
                    if (selectedValue) {
                        this.el.val(selectedValue);
                        if (this.options.autoSubmit) {
                            f = this.el.parents('form');
                            if (f.length > 0) {
                                f.get(0).submit();
                            }
                        }
                        this.ignoreValueChange = true;
                        this.hide();
                        this.onProductSelect(i);
                    }
                },

                select(i) {
                    let selectedValue, f;
                    let divs = this.suggestionsContainer.children('div');

                    if ($(divs[i]).attr('data-href')) {
                        document.location = $(divs[i]).attr('data-href');
                    }
                    selectedValue = this.suggestions[i];
                    if (selectedValue) {
                        this.el.val(selectedValue);
                        if (this.options.autoSubmit) {
                            f = this.el.parents('form');
                            if (f.length > 0) {
                                f.get(0).submit();
                            }
                        }
                        this.ignoreValueChange = true;
                        this.hide();
                        this.onSelect(i);
                    }
                },

                moveUp() {
                    if (this.selectedIndex === -1) {
                        return;
                    }
                    if (this.selectedIndex === 0) {
                        this.suggestionsContainer.children().get(0).className = '';
                        this.selectedIndex = -1;
                        this.el.val(this.currentValue);
                        return;
                    }
                    this.adjustScroll(this.selectedIndex - 1);
                },

                moveDown() {
                    if (this.selectedIndex === (this.suggestions.length - 1)) {
                        return;
                    }
                    this.adjustScroll(this.selectedIndex + 1);
                },

                adjustScroll(i) {
                    let activeItem = this.activate(i);
                    let offsetTop = activeItem.offsetTop;
                    let upperBound = this.suggestionsContainer.scrollTop();
                    let lowerBound = upperBound + this.options.maxHeight - 25;

                    if (offsetTop < upperBound) {
                        this.suggestionsContainer.scrollTop(offsetTop);
                    } else if (offsetTop > lowerBound) {
                        this.suggestionsContainer.scrollTop(offsetTop - this.options.maxHeight + 25);
                    }
                    let divs = this.suggestionsContainer.children('div');
                    this.el.val($(divs[i]).text());
                },

                onSelect(i) {
                    let fn = this.options.onSelect;
                    let suggestion = this.suggestions[i];
                    let data = this.data[i];
                    this.el.val(this.getValue(suggestion));
                    if ($.isFunction(fn)) {
                        fn(suggestion, data, this.el);
                    }
                },

                onProductSelect(i) {
                    let fn = this.options.onSelect;
                    let suggestion = this.suggestions[0];
                    this.el.val(this.getValue(suggestion));
                    if ($.isFunction(fn)) {
                        fn(s, data, this.el);
                    }
                },

                getValue(value) {
                    let del = this.options.delimiter;
                    if (!del) {
                        return value;
                    }
                    let currValue = this.currentValue;
                    let arr = currValue.split(del);

                    if (arr.length === 1) {
                        return value;
                    }
                    return currValue.substr(0, currValue.length - arr[arr.length - 1].length) + value;
                },

                showResults() {
                    this.container.addClass('is-active');
                    $(".js_overlay-autocomplete").addClass('is-active');
                },

                hideResults() {
                    this.container.removeClass('is-active');
                    this.suggestionsContainer.empty();

                    if(!$('.mainNavBar.js-mainNavBar').hasClass('is-active')){
                        $(".js_overlay-autocomplete").removeClass('is-active');
                    }
                }
            };
        }(jQuery));
    }
}
